import React from "react";

const Badge = ({ color, children, style }) => {
  return (
    <div className={`badge badge-pill bg-${color}`} style={style}>
      {children}
    </div>
  );
};

export default Badge;
